import { useAuth } from "../contexts/AuthProvider";

export default function RouteWrapper({ loggedComponent, defaultComponent }) {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return null;
    }

    if (isAuthenticated) {
        return loggedComponent;
    }

    return defaultComponent;
};
